import { render, staticRenderFns } from "./SpotifyAuthorization.vue?vue&type=template&id=765ac080&scoped=true&"
import script from "./SpotifyAuthorization.vue?vue&type=script&lang=js&"
export * from "./SpotifyAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./SpotifyAuthorization.vue?vue&type=style&index=0&id=765ac080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ac080",
  null
  
)

export default component.exports